module.exports = __webpack_public_path__ + "static/img/14.d240cd1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/eng/14.png
// module id = MzFB
// module chunks = 0